import { GET_SINGLE_POST } from "../actions/post.actions";

// Slice dédié à la vue d'un post unique (/post/:id). Séparé du fil pour ne pas
// transformer postReducer (un tableau) en objet.
const initialState = {};

export default function singlePostReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SINGLE_POST:
      return action.payload;
    default:
      return state;
  }
}
